import { createContext, useContext } from 'react';

export const LanguageContext = createContext({ t: (key) => key });

export function useLanguage() {
  return useContext(LanguageContext);
}

// Simple interpolation: t("welcome_back", { name: "Thomas" }) → "Welcome back, Thomas"
export function translate(translations, key, vars = {}) {
  let str = translations[key] ?? key;
  Object.entries(vars).forEach(([k, v]) => {
    str = str.replace(`{{${k}}}`, v);
  });
  return str;
}
